import {Component, OnInit, OnDestroy , ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Filters, Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-client-specific-url',
    templateUrl: './client-specific-url.component.html',
    styleUrls: ['./client-specific-url.component.css']
})
export class ClientSpecificUrlComponent implements OnInit, OnDestroy {

    clientName: string;
    description: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;
    urlSelected: number;
    urlArr = [];
    url: string;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private adminAuth: Subscription;

    private notifier: NotifierService;
    offset: number;
    urlKey: string;
    clients = [];
    clientSelected: number;
    isAdmin: boolean;
    isDashboard: boolean;
    dataLoaded:boolean;
    showSearch = true;
    isLoading = false;
    keySelected: any;
    urls: any;
    des: string;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;





    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                        }
                    }
                    break;
                case 'delete':
                    console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteClientSpecificUrl({user_id: this.messageService.getUserId(), id: item.id}).subscribe((res) => {
                                this.respObject = res;
                                // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.notifier.notify('success', 'URL Deleted successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded=false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Client Specific URL',
            openModalButton: 'Add URL',
            searchModalButton: 'Search',
            breadcrumb: 'Client Specific URL',
            folderName: 'All Client Specific URL',
            tabName: 'Client Specific URL',
            exportBtn: 'Export to excel'

        };

        this._rest.getUrlList().subscribe((res) => {
            this.respObject = res;
            this.respObject.details.unshift({id: 0, name: 'Select URL key'});
            this.urlArr = this.respObject.details;
            this.urlSelected = 0;
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });

        this._rest.getClient().subscribe((res) => {
            this.respObject = res;
            // console.log(JSON.stringify(this.respObject.clients));
            if (this.respObject.success) {
                this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                this.clients = this.respObject.clients;
                this.clientSelected = 0;
            } else {

            }
        }, function (err) {

        });
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'client_name', name: 'client Name', field: 'client_name', sortable: true, filterable: true
            }, {
                id: 'urlkey', name: 'URL Key', field: 'url_key', sortable: true, filterable: true
            }, {
                id: 'url', name: 'url', field: 'url', sortable: true, filterable: true
            }, {
                id: 'isAdmin', name: 'isAdmin', field: 'isAdmin', sortable: true, filterable: true, formatter: Formatters.checkmark,
                filter: {
                    collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
                    model: Filters.singleSelect,

                    filterOptions: {
                        autoDropWidth: true
                    },
                }
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
    }

    onPageLoad() {
        this.getTableData();
    }


    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllClientSpecificUrl(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;

                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    searchModal() {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.urlSelected = 0;
            this.url = '';
            this.isAdmin = false;
            this.isDashboard = false;
            this.keySelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
                this.searchModalReference.result.then((result) => {
                }, (reason) => {
    
                });
        }

    }


    search() {
        this._rest.searchAllClientSpecificUrl(this.keySelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.urls = this.respObject.details;
                this.messageService.setTotalData(this.urls.length);
                this.messageService.setGridData(this.urls);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.urlSelected = 0;
            this.url = '';
            this.isAdmin = false;
            this.isDashboard = false;
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
        }

    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        const data = {
            clientId: this.clientSelected, urlId: this.urlSelected, url: this.url, createdBy: this.messageService.getUserId()
        };
        if (!this.messageService.isBlankField(data)) {
            if (this.isDashboard) {
                data['isAdmin'] = this.isAdmin + '';
            }
            this._rest.addClientSpecificUrl(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    this.isError = false;
                    const id = this.respObject.details;
                    this.messageService.setRow({
                        id: id,
                        client_name: this.clientName,
                        url_key: this.urlKey,
                        url: this.url,
                        isAdmin: this.isAdmin
                    });
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    this.clientSelected = 0;
                    this.urlSelected = 0;
                    this.isAdmin = false;
                    this.isDashboard = false;
                    this.url = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }

    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    onUrlKeyChange(selectedIndex: any) {
        this.urlKey = this.urlArr[selectedIndex].name;
        if (this.urlKey === 'dashboard') {
            this.isDashboard = true;
            this.isAdmin = false;
        } else {
            this.isDashboard = false;
        }
    }

    onClientChange(value: any) {
        this.clientName = this.clients[value].name;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getClientSpecificUrl(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }

}
